__webpack_require__.p = "/select-shared-provider-bulk-actions/referrals-hub/";